import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import { StackedCoinsIcon, Star02 } from 'components/SVG';
import React from 'react';
import UsageChart from './UsageChart';
import { useAddChartData } from 'hooks/history/useChartData';
import { HistoryFilter } from '.';
import SparksHistoryResultSkeleton from 'sharedComponents/Skeleton/HistorySkeleton/SparksHistoryResultSkeleton';
type UsageTabProps = {
  historyFilter: HistoryFilter;
};
function UsageTab({ historyFilter }: UsageTabProps) {
  const {
    sparkRunsChartData,
    creditsUsedChartData,
    timeUnit,
    totals,
    isLoading,
  } = useAddChartData(historyFilter);
  if (isLoading) {
    return <SparksHistoryResultSkeleton />;
  }

  return (
    <Grid container gap={2}>
      <Grid container item display='flex' justifyContent='center' gap={4}>
        <Box
          width='449px'
          height='118px'
          display='flex'
          alignItems='center'
          sx={{ background: '#ECEFFE', borderRadius: '10px' }}
        >
          <Box display='flex'>
            <Box
              width='65px'
              height='65px'
              display='flex'
              alignItems='center'
              justifyContent='center'
              ml={4}
              sx={{
                background: '#6267AC',
                borderRadius: '10px',
              }}
            >
              <SvgIcon
                sx={{
                  stroke: 'white',
                }}
              >
                <Star02 />
              </SvgIcon>
            </Box>

            <Box display='flex' flexDirection='column' pl='15px'>
              <Typography sx={{ fontSize: '30px', color: '#6267AC' }}>
                {totals?.totalSparkRuns}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: '#404040' }}>
                Spark Runs
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          width='449px'
          height='118px'
          display='flex'
          alignItems='center'
          sx={{ background: '#ECEFFE', borderRadius: '10px' }}
        >
          <Box display='flex'>
            <Box
              width='65px'
              height='65px'
              display='flex'
              alignItems='center'
              justifyContent='center'
              ml={4}
              sx={{
                background: '#6267AC',
                borderRadius: '10px',
              }}
            >
              <SvgIcon
                sx={{
                  stroke: 'white',
                }}
              >
                <StackedCoinsIcon />
              </SvgIcon>
            </Box>
            <Box display='flex' flexDirection='column' pl='15px'>
              <Typography sx={{ fontSize: '30px', color: '#6267AC' }}>
                {totals?.totalCreditsUsed}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: '#404040' }}>
                Credits Used
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
      {!!sparkRunsChartData?.length &&
        !!creditsUsedChartData?.length &&
        totals && (
          <Box width='100%'>
            <UsageChart
              sparkRunsChartData={sparkRunsChartData}
              creditsUsedChartData={creditsUsedChartData}
              timeUnit={timeUnit}
            />
          </Box>
        )}
    </Grid>
  );
}

export default UsageTab;
